/**
 * Route guard para rutas protegidas del portal de solicitantes.
 * Verifica que el usuario esté autenticado.
 * Si no, redirige a /login.
 */

import { useAuth } from "@/_core/hooks/useAuth";
import { Spinner } from "@/components/ui/spinner";
import type { ComponentType } from "react";

interface ProtectedRouteProps {
  component: ComponentType<any>;
  [key: string]: unknown;
}

export function ProtectedRoute({ component: Component, ...rest }: ProtectedRouteProps) {
  const { user, loading } = useAuth({ redirectOnUnauthenticated: true });

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spinner className="size-8" />
      </div>
    );
  }

  if (!user) return null;

  return <Component {...rest} />;
}
